<template>
  <dv-full-screen-container class="bg">
    <div class="header"></div>
    <div class="item-wrap">
      <div class="item1"></div>
      <div class="item2" @click="go('/dataScreenView2')"></div>
      <div class="item3"></div>
      <div class="item4"></div>
    </div>
  </dv-full-screen-container>
</template>

<script>
export default {
  name: "first",
  data() {
    return {}
  },
  methods:{
    go(name){
      this.$router.push(name)
    }
  }
}
</script>

<style scoped>
.bg {
  background-image: url(../assets/2/bg2.png);
  background-position: 0 0;
}
.header{
  background-image: url(../assets/2/header.png);
  background-color: transparent;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:150px;
  background-repeat: no-repeat;
}
.item-wrap{
  position:absolute;
  left:183px;
  top:33%;
  width:80%;
  height:500px;
  display: flex;
}
.item-wrap>div{
  width:25%;
  height:500px;
  background-repeat: no-repeat;
  background-position: center center;
  cursor:pointer;
}
.item1{
  background-image: url(../assets/2/1.png);
  padding-top:134px;
}
.item2{
  background-image: url(../assets/2/2.png);
  margin-top:50px;
}
.item3{
  background-image: url(../assets/2/3.png);
  margin-top:50px;
}
.item4{
  background-image: url(../assets/2/4.png);
  margin-top:27px;
}

</style>